import ActionType from '@/apps/slideshowGame/ActionType';

export const slide33 = {
  id: 'slide33_fragments',
  initial: 'fragment1',
  states: {
    fragment1: {
      on: {
        [ActionType.EMOTION]: { target: '#slides.slide34' },
        [ActionType.INTUITIVE]: { target: '#slides.slide35' },
        [ActionType.PROCRASTINATION]: { target: '#slides.slide36' },
        [ActionType.RATIONAL]: { target: '#slides.slide37' },
      },
      meta: {
        id: 'fragment1',
        name: 'vs_choice',
        content: {
          src: 'https://res.cloudinary.com/dcodkxpej/image/upload/v1722191519/Decision%20making%20game/boy/rewsjloj9t2k2mbfuegf.png',
          border: 'border-[#F6652A]',
          images: [
            'https://res.cloudinary.com/dcodkxpej/image/upload/v1722189067/Decision%20making%20game/boy/w3yzyvcxqyqdew2kwjnb.svg',
            'https://res.cloudinary.com/dcodkxpej/image/upload/v1721801705/Decision%20making%20game/boy/wvcymzob5xuq3ugrgwvy.svg',
          ],
          title:
            'מתלבט- ללכת להופעה עם חברים או\n לפתוח דוכן ולהתרכז במכירות?              ',
          options: [
            {
              event: ActionType.EMOTION,
              title: 'הולך עם החברים. הדוכן יישאר היום סגור.                  ',
            },
            {
              event: ActionType.INTUITIVE,
              title:
                'מה הבעיה? גם וגם! לא יודע איך, אבל אני אמצא פתרון.                    ',
            },
            {
              event: ActionType.PROCRASTINATION,
              title: 'מחכה לראות איזה חברים באים',
            },
            {
              event: ActionType.RATIONAL,
              title: 'יש מוסר עבודה. מוותר על ההופעה.',
            },
          ],
        },
      },
    },
  },
  meta: {
    id: 'slide33',
    section: '65f2c85f8861cdcb662a47d4',
    display: {
      backgroundColor: '#FAD937',
      backgroundGradient: '',
      backgroundImage: '',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-no-repeat',
      backgroundOpacity: 1,
      backgroundVideo: '',
      transition: 'slide',
      transitionSpeed: 'default',
      backgroundTransition: 'fade',
    },
    content: [
      {
        name: 'base_text',
        type: 'content',
        content: {
          color: 'text-dark',
          title: 'הלהקה האהובה עלי- "הכפרות"\n מגיעה להופיע בפארק.',
        },
      },
    ],
  },
};
export default slide33;
